/* eslint-disable */
import React from "react";
import { Link, withRouter } from "react-router-dom";


let role_type = localStorage.getItem('role_type');


const CustomerSettingSidebar = (props) => {
  let pathName = props.location.pathname;
  return (
    <div className="card">
      <div className="card-body">
        <div className="widget settings-menu">
          <ul>
            <li className="nav-item">
              <Link
                to="/customerportal/update-profile"
                className={`${
                  "/customerportal/update-profile" === pathName
                    ? "active nav-link"
                    : "nav-link"
                }`}
              >
                <i className="far fa-user"></i> <span> Profile</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/customerportal/change-password"
                className={`${
                  "/customerportal/change-password" === pathName
                    ? "active nav-link"
                    : "nav-link"
                }`}
              >
                <i className="fas fa-cog"></i> <span>Change Password</span>
              </Link>
            </li>
              
              {role_type == 1 && (
                  <li className="nav-item">
                  <Link
                    to="/customerportal/users"
                    className={`${
                      "/customerportal/users" === pathName
                        ? "active nav-link"
                        : "nav-link"
                    }`}
                  >
                    <i className="fas fa-users"></i> <span>Users</span>
                  </Link>
                  </li>
              )}
             
           
          </ul>
        </div>
      </div>
    </div>
  );
};
export default withRouter(CustomerSettingSidebar);
